import { ContaRecorrenteContentReceita } from "components/Features/Financeiro/ContaRecorrente";
import { useBreadcrumb } from "features/breadcrumbs";

function ContaRecorrenteReceitaPage() {
  useBreadcrumb([
    { name: "Financeiro", url: "/financeiro" },
    { name: "Receitas", url: "/financeiro/receita" },
    {
      name: "Receitas recorrentes",
      url: "/financeiro/receita/conta-recorrente",
    },
  ]);

  return (
    <>
      <ContaRecorrenteContentReceita />
    </>
  );
}

export default ContaRecorrenteReceitaPage;
